import styled from "styled-components";
import { grayDark, white } from "../styles/colors";
import { ScrollReveal } from "./ScrollReveal";
import { StoreBadges } from "./StoreBadges";

export function CTA() {
  return (
    <Section>
      <Inner>
        <ScrollReveal>
          <Title>Start your timeline today</Title>
          <Subtitle>
            Every step forward is a story worth telling. Download Progress and
            capture the journey while it&apos;s happening — not after the fact.
          </Subtitle>
          <StoreBadges size="large" />
        </ScrollReveal>
      </Inner>
    </Section>
  );
}

const Section = styled.section({
  padding: "96px 24px 112px",
  background: white,
});

const Inner = styled.div({
  maxWidth: 680,
  margin: "0 auto",
  textAlign: "center",
});

const Title = styled.h2({
  margin: "0 0 16px",
  fontSize: "clamp(32px, 4vw, 48px)",
  fontWeight: 700,
  letterSpacing: "-0.03em",
});

const Subtitle = styled.p({
  margin: "0 0 36px",
  fontSize: 18,
  lineHeight: 1.75,
  color: grayDark,
});
